import { render, staticRenderFns } from "./POSLayout.vue?vue&type=template&id=2cf92060&"
import script from "./POSLayout.vue?vue&type=script&lang=js&"
export * from "./POSLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports